import axios from "axios";
import { axiosInstance } from "./intreceptor";

let cache = {};
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

class companyService {

	  getActiveCompany  = () => {
        return axiosInstance
        .get(`/company/getactivecompanies`)
        .then(response => {
          return response.data
        })
        .catch((err) => {
          console.log(err);
        });
      }

}

export default new companyService()
